{
  "auth": {
    "agree": "I agree to",
    "createAccount": "Create account",
    "createNewAccount": "Create New Account",
    "email": "Email",
    "login": "Login",
    "password": "Password",
    "recover_password": "Recover password",
    "sign_up": "Sign Up",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Terms of Use.",
    "reset_password": "Reset password"
  },
  "404": {
    "title": "This page's gone fishing.",
    "text": "If you feel that it's not right, please send us a message at ",
    "back_button": "Back to dashboard"
  },
  "typography": {
    "primary": "Primary text styles",
    "secondary": "Secondary text styles"
  },
  "dashboard": {
    "versions": "Versions",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "navigationLayout": "navigation layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Side Bar"
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian"
  },
  "menu": {
    "auth": "Auth",
    "buttons": "Buttons",
    "timelines": "Timelines",
    "dashboard": "Dashboard",
    "billing": "Sales",
    "login": "Login",
    "preferences": "Account preferences",
    "payments": "Payments",
    "settings": "Application settings",
    "pricing-plans": "Pricing plans",
    "payment-methods": "Payment methods",
    "signup": "Signup",
    "recover-password": "Recover password",
    "recover-password-email": "Recover password email",
    "404": "404",
    "faq": "FAQ",
    "users": "Users",
    "projects": "Projects",
    "clients": "Clients",
    "sales": "Sales",
    "finance": "Finance",
    "financeDashboard": "Finance Dashboard",
    "financialReports": "Financial Reports",
    "activeUsers": "Active Users",
    "staff": "Staff",
    "invitations": "Invitations",
    "setup": "Setup",
    "items": "Items",
    "roles": "Roles",
    "configurations": "Configurations",
    "inventory": "Inventory",
    "inventoryDashboard": "Dashboard",
    "inventoryItems": "Inventory Items",
    "inventoryLocations": "Inventory locations",
    "stockIn": "Stock In",
    "stockOut": "Stock out",
    "stockTake": "Stock Take",
    "transfers": "Transfers",
    "procurement": "Procurement",
    "suppliers": "Suppliers",
    "expenses": "Expenses",
    "commissions": "Commissions",
    "catalog": "Catalog",
    "products": "Products (Items)",
    "unitsOfMeasure": "Units of Measure",
    "servicesCatalog": "Services",
    "salesOrders": "Sales orders",
    "invoices": "Invoices",
    "financeOverview": "Overview",
    "financePayments": "Payments",
    "transactions": "Transactions",
    "reports": "Reports",
    "financeReports": "Finance reports",
    "itemsReports": "Items",
    "usersAndRoles": "Users & roles",
    "systemUsers": "Active users",
    "rolesAndPermissions": "Roles & permissions",
    "settingsApplication": "Settings",
    "companySettings": "Company settings",
    "dataImports": "Data Imports"
  },
  "messages": {
    "all": "See all messages",
    "new": "New messages from {name}",
    "mark_as_read": "Mark As Read"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo"
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications",
    "mark_as_read": "Mark as read",
    "sentMessage": "sent you a message",
    "uploadedZip": "uploaded a new Zip file with {type}",
    "startedTopic": "started a new topic"
  },
  "user": {
    "language": "Change language",
    "logout": "Logout",
    "profile": "Profile",
    "settings": "Settings",
    "billing": "Sales",
    "faq": "FAQ",
    "helpAndSupport": "Help & support",
    "projects": "Projects",
    "account": "Account",
    "explore": "Explore"
  },
  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Send"
  },
  "spacingPlayground": {
    "value": "Value",
    "margin": "Margin",
    "padding": "Padding"
  },
  "spacing": {
    "title": "Spacing"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Row height",
    "title": {
      "default": "Default",
      "withControls": "With controls",
      "customHeader": "Custom header",
      "withoutHeader": "Without header",
      "withImage": "With Image",
      "withTitleOnImage": "With title on image",
      "withCustomTitleOnImage": "With custom title on image",
      "withStripe": "With stripe",
      "withBackground": "With background"
    },
    "button": {
      "main": "Main",
      "cancel": "Cancel",
      "showMore": "Show More",
      "readMore": "Show More"
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Leave feedback",
      "readFull": "Read full article",
      "secondaryAction": "Secondary action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Theme Colors",
    "extraColors": "Extra Colors",
    "gradients": {
      "basic": {
        "title": "Button Gradients"
      },
      "hovered": {
        "title": "Hovered Button Gradients",
        "text": "Lighten 15% applied to an original style (gradient or flat color) for hover state."
      },
      "pressed": {
        "title": "Pressed Button Gradients",
        "text": "Darken 15% applied to an original style (gradient or flat color) for pressed state."
      }
    }
  },
  "tabs": {
    "alignment": "Tabs alignment",
    "overflow": "Tabs overflow",
    "hidden": "Tabs with hidden slider",
    "grow": "Tabs grow"
  },
  "helpAndSupport": "Help & support",
  "aboutVuesticAdmin": "About Vuestic Admin",
  "search": {
    "placeholder": "Search..."
  },
  "expense": {
    "tabs": {
      "expenses": "Expenses",
      "expenseItems": "Expense items",
      "expenseCategories": "Expense categories"
    },
    "recordsPlaceholder": "Expense records will be available in this tab in a separate change.",
    "records": {
      "registrationHeading": "Expense header",
      "referenceNumber": "Reference number",
      "expenseDate": "Expense date",
      "totalAmount": "Total amount",
      "notes": "Notes",
      "linesHeading": "Expense lines",
      "addLineHeading": "Add expense line",
      "linesEmptyState": "No expense lines added yet. Use the form above to add lines.",
      "removeLineConfirmTitle": "Remove line",
      "removeLineConfirmMessage": "Are you sure you want to remove this expense line?",
      "removeLineConfirmOk": "Remove",
      "linesCountSuffix": "line(s)",
      "selectCategory": "Select category",
      "selectExpenseItem": "Select expense item",
      "validationSelectCategory": "Please select an expense category.",
      "validationSelectItem": "Please select an expense item.",
      "validationAmountRequired": "Amount is required.",
      "validationAmountPositive": "Amount must be greater than zero.",
      "validationDescriptionRequired": "Description is required.",
      "validationFixLine": "Please fix the line details before adding.",
      "addLine": "Add line",
      "submit": "Submit expense",
      "submitConfirmTitle": "Confirm expense",
      "submitConfirmMessage": "Submit this expense for {total} with {count} line(s)?",
      "submitConfirmOk": "Submit expense",
      "expenseItem": "Expense item",
      "amount": "Amount",
      "displayDetailed": "Detailed",
      "displaySummary": "Summary",
      "registerExpense": "Register expense",
      "search": "Search",
      "filterExpenseNumber": "Expense number",
      "filterReferenceNumber": "Reference number",
      "filterStartDate": "From date",
      "filterEndDate": "To date",
      "applyFilters": "Apply filters",
      "clearFilters": "Clear",
      "expenseNumber": "Expense number",
      "viewDetails": "View details",
      "resultsSuffix": "results.",
      "perPage": "Per page",
      "listLoadFailed": "Could not load expenses. Please try again.",
      "listEmptySummary": "No expense records found for the current filters.",
      "listEmptyDetailed": "No expense line items found for the current filters.",
      "saveFailed": "Could not save the expense. Please try again.",
      "noDetail": "No expense details available."
    },
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "yes": "Yes",
    "no": "No",
    "modal": {
      "createExpenseItem": "Create expense item",
      "editExpenseItem": "Edit expense item",
      "createExpenseCategory": "Create expense category",
      "editExpenseCategory": "Edit expense category",
      "registerExpense": "Register expense",
      "expenseLinesTitle": "Expense lines"
    },
    "columns": {
      "name": "Name",
      "code": "Code",
      "description": "Description",
      "status": "Status",
      "category": "Category",
      "defaultAmount": "Default amount",
      "item": "Item"
    },
    "form": {
      "expenseCategory": "Expense category",
      "name": "Name",
      "code": "Code",
      "defaultAmount": "Default amount",
      "description": "Description",
      "active": "Active",
      "save": "Save",
      "cancel": "Cancel"
    },
    "categoriesLoadFailed": "Could not load expense categories. Please try again.",
    "itemsLoadFailed": "Could not load expense items. Please try again.",
    "validation": {
      "atLeastOneLine": "Add at least one expense line.",
      "expenseDateRequired": "Expense date is required.",
      "expenseDateNotInFuture": "Expense date cannot be in the future.",
      "totalMustBePositive": "Total amount must be greater than zero."
    },
    "toasts": {
      "categoryCreated": "Expense category created successfully",
      "categoryUpdated": "Expense category updated successfully",
      "categoryDeleted": "Expense category deleted successfully",
      "itemCreated": "Expense item created successfully",
      "itemUpdated": "Expense item updated successfully",
      "itemDeleted": "Expense item deleted successfully",
      "expenseCreated": "Expense registered successfully"
    }
  },
  "commission": {
    "tabs": {
      "rules": "Commission Rules",
      "ledger": "Commission Ledger",
      "reports": "Commission Reports"
    },
    "comingSoon": "This section is coming soon.",
    "allStaff": "All staff",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "modal": {
      "createRule": "Create commission rule",
      "editRule": "Edit commission rule"
    },
    "columns": {
      "name": "Name",
      "ruleType": "Rule Type",
      "commissionType": "Commission Type",
      "commissionValue": "Commission Value",
      "maxCommissionPercentage": "Max Commission Percentage",
      "staff": "Staff",
      "staffFilter": "Staff",
      "itemCategory": "Item Category",
      "itemType": "Item Type",
      "item": "Item",
      "priority": "Priority",
      "status": "Status",
      "effectiveFrom": "Effective From",
      "effectiveTo": "Effective To",
      "effectivePeriod": "Effective Period",
      "createdAt": "Created At"
    },
    "form": {
      "name": "Name",
      "staff": "Staff (optional)",
      "staffPlaceholder": "All staff — generic rule",
      "staffHint": "Leave empty for a generic rule. Select a staff member to create a staff-specific override that takes priority over the generic rules.",
      "ruleType": "Rule Type",
      "commissionType": "Commission Type",
      "commissionValue": "Commission Value",
      "commissionValueMin": "Commission value must be greater than zero",
      "priority": "Priority",
      "item": "Item",
      "itemType": "Item Type",
      "itemCategory": "Item Category",
      "effectiveFrom": "Effective From",
      "effectiveTo": "Effective To",
      "effectiveFromNotPast": "Effective From cannot be before today",
      "effectiveToNotPast": "Effective To cannot be before today",
      "effectiveFromNotAfterTo": "Effective From cannot be after Effective To",
      "effectiveToNotBeforeFrom": "Effective To cannot be before Effective From",
      "active": "Active",
      "save": "Save",
      "cancel": "Cancel",
      "percentageMax": "Percentage cannot exceed 100"
    },
    "errors": {
      "loadFailed": "Unable to load commission rules. Please try again later.",
      "saveFailed": "Unable to save commission rule. Please try again."
    },
    "toasts": {
      "ruleCreated": "Commission rule created successfully",
      "ruleUpdated": "Commission rule updated successfully",
      "ruleDeleted": "Commission rule deleted successfully"
    }
  },
  "import": {
    "pageTitle": "Data Imports",
    "noPermission": "You do not have permission to view data imports.",
    "readOnlyMessage": "You can view import history but do not have permission to run imports.",
    "tabs": {
      "newImport": "New Import",
      "history": "Import History"
    },
    "importType": "Import Type",
    "fileUpload": "File Upload",
    "uploadFile": "Upload File",
    "acceptedFormats": "Accepted formats: CSV (.csv) and Excel (.xlsx). Maximum size: 10 MB.",
    "invalidFileType": "Please select a CSV (.csv) or Excel (.xlsx) file.",
    "fileTooLarge": "The selected file exceeds the maximum size of 10 MB.",
    "uploadSuccess": "File uploaded successfully: {filename}",
    "uploadedFile": "your file",
    "validationInProgressBanner": "Validation is still in progress.",
    "importInProgressBanner": "Import is still in progress.",
    "viewProgress": "View Progress",
    "duplicateHandling": "Duplicate Handling",
    "validationProgress": "Validation Progress",
    "uploading": "Uploading...",
    "fileUploaded": "File uploaded",
    "validating": "Validating...",
    "progress": "Progress",
    "validationSummary": "Validation Summary",
    "validationFailedTitle": "Validation Failed",
    "validationFailedMessage": "Validation failed. Review the errors below, fix your file, and start a new import.",
    "validationNoValidRowsMessage": "No valid rows were found. Review the errors below, fix your file, and start a new import.",
    "validationPartialFailureMessage": "{failed} row(s) failed validation. You can import the {valid} valid row(s) or upload a corrected file.",
    "totalRows": "Total Rows",
    "validRows": "Valid Rows",
    "failedRows": "Failed Rows",
    "validationErrors": "Validation Errors",
    "showingRows": "Showing {from}–{to} of {total} errors",
    "previous": "Previous",
    "next": "Next",
    "startImport": "Start Import",
    "importProgress": "Import Progress",
    "importing": "Importing...",
    "processed": "Processed",
    "imported": "Imported",
    "failed": "Failed",
    "importCompleted": "Import Completed",
    "importFailed": "Import Failed",
    "importCancelled": "Import Cancelled",
    "duration": "Duration",
    "newImport": "New Import",
    "viewHistory": "View Import History",
    "confirmImportTitle": "Confirm Import",
    "confirmImportMessage": "{total} rows uploaded. {valid} valid, {invalid} invalid. Proceed with importing the valid rows?",
    "cancel": "Cancel",
    "proceed": "Proceed",
    "downloadTemplate": "Download {type} Import Template",
    "noHistory": "No import history found.",
    "historyPage": "Page {page} of {total}",
    "historyColumns": {
      "type": "Type",
      "status": "Status",
      "progress": "Progress",
      "duplicateHandling": "Duplicate Handling",
      "totalRows": "Total Rows",
      "imported": "Imported",
      "failed": "Failed",
      "validationCompleted": "Validation Completed",
      "importStarted": "Import Started",
      "importCompleted": "Import Completed",
      "created": "Created",
      "createdBy": "Created By"
    }
  },
  "buttonSelect": {
    "dark": "Dark",
    "light": "Light"
  },
  "inventoryHealth": {
    "pageTitle": "Inventory Dashboard",
    "pageSubtitle": "Stock and expiry issues that need attention.",
    "pageSubtitleAtLocation": "Stock and expiry issues that need attention at {location}.",
    "asOfDate": "As of {date}",
    "permissionDenied": "You do not have permission to view inventory health counts.",
    "selectWarehouse": "Select a warehouse to see inventory health counts for that location.",
    "loadError": "Could not load inventory health counts.",
    "retry": "Retry",
    "allClear": "No low-stock or expiry issues at this location.",
    "allItems": "All items",
    "filterToolbarAria": "Stock and expiry filters",
    "stockSection": "Stock",
    "expirySection": "Expiry",
    "cardClear": "All clear",
    "cardAlert": "Attention",
    "attentionSummary": "items need attention",
    "badgeNeedsAttention": "Needs attention",
    "badgePlanAction": "Plan action",
    "badgeTakeAction": "Take action",
    "lowStock": "Low Stock",
    "lowStockSubtitle": "Items at or below the reorder level",
    "outOfStock": "Out of Stock",
    "outOfStockSubtitle": "No available stock at this location",
    "inStock": "In Stock",
    "expiringSoon": "Expiring Soon",
    "expiringSoonSubtitle": "Batches in the expiry alert window",
    "expiringSoonSubtitleDays": "Batches expiring within {days} days",
    "expired": "Expired",
    "expiredSubtitle": "Items with expired batches",
    "expiredSubtitleBatches": "{count} expired batches at {location}",
    "viewLowStock": "View low stock items",
    "viewOutOfStock": "View out of stock items",
    "viewExpiring": "View expiring items",
    "viewExpired": "View expired items",
    "glanceTitle": "Inventory at a Glance",
    "totalItems": "Total Items",
    "totalItemsSubtitle": "Across all categories",
    "totalBatches": "Total Batches",
    "totalBatchesSubtitle": "Active batches",
    "totalLocations": "Total Locations",
    "totalLocationsSubtitle": "Active stock locations",
    "totalLocationsSubtitleNamed": "{location}",
    "totalLocationsSubtitleOthers": "{location} + {count} others",
    "itemsInStock": "Items in Stock",
    "itemsInStockSubtitle": "{percent}% of total items",
    "stockBreakdownTitle": "Stock Breakdown",
    "totalIssues": "Total issues",
    "quickActionsTitle": "Quick Actions",
    "quickActionAdjustStock": "Adjust Stock",
    "quickActionViewReports": "View Reports",
    "quickActionManageItems": "Manage Items",
    "quickActionStockIn": "Stock In",
    "quickActionCreatePurchaseOrder": "Create Purchase Order",
    "focusHintExpired": "Expired lots are highlighted.",
    "focusHintExpiringSoon": "Expiring soon lots are highlighted.",
    "stockByLocationEmpty": "No location-level stock returned for this item.",
    "stockByLocationLoadError": "Failed to load stock by location.",
    "viewItems": "View items",
    "cardAria": "{label}: {count}. Open filtered items."
  }
}
